import {Component} from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.scss'],
    imports: [RouterLink]
})
export class TermsComponent {

  year: number = new Date().getFullYear();

}
